import classes from './MealsSummary.module.css';

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Delicious Food delivered To You with Love!</h2>
      <p>
      Food for thought- have you ever met anyone who doesn't like Italian cuisine? We haven't! 
      Cheesy pizza, flavorful pasta, and heavenly panna cotta, just thinking about these delicacies makes me drool.
      </p>
      <p>
       Since time immemorial Italian cuisine has enjoyed a universal appeal.  Whether it's the emphasis on 
      using fresh produce in Italian preparations or the blend of simple ingredients that result in one 
      flavor-packed delight, there's no one answer to what makes Italian cuisine so famous.  
      </p>
    </section>
  );
};

export default MealsSummary;
